import { useState } from 'react'

import { Box, Flex, Heading, Button, FormControl, Input, FormHelperText, Text, useToast } from "@chakra-ui/react"

import {toastOptions} from '../../utils/client/toast'

import {isEmail} from '../../utils/client'

import { useRouter } from 'next/router'

import axios from 'axios'

const ReminderForm = () => {
	const [email, setEmail] = useState('')
	const [sent, setSent] = useState(false)
	const toast = useToast()
    const router = useRouter()

    const remindByEmail = async () => {
        if (isEmail(email)) {
            setSent(true)
            await axios.post(`/api/reminder/send`, { email }, { headers: { 'Content-Type': 'application/json' } })
        } else {
            toast({ title: "Oops 🙈", variant: 'subtle', description: "Email is invalid", status: "error", ...toastOptions })
        }
    }
	return (
        <Flex margin="20px" display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100%">
            <Box marginBottom="80px" maxW="280px" textAlign="center">
                <Heading size="xl" marginBottom="20px">Mobile support is<br/> in the works ⏳</Heading>
                {!sent ? <>
                    <Text marginBottom="20px">Get a reminder to use Pretty Funnels later when you are on your desktop!</Text>
                    <FormControl marginBottom="40px">
                        <Input type="email" marginBottom="20px" placeholder="eg. seth@godin.com" onChange={(e) => setEmail(e.target.value)} required />
                        <Button colorScheme="purple" onClick={remindByEmail}>Remind me later</Button>
                        <FormHelperText>We'll only email you once.</FormHelperText>
                    </FormControl>
                </> :
                <>
                    <Text marginBottom="20px">We'll send you an email<br/> in a few hours. ✅</Text>
                    <Text display="block" marginBottom="20px" textColor="var(--chakra-colors-purple-500)" onClick={() => setSent(false)}><u>I want to enter a different email</u></Text>
                    <Button onClick={() => router.push('/landing')} size="sm">More about Pretty Funnels 🔥</Button>
                    {/* <Box position="relative">
                        <Flex flexDirection="column" alignItems="center" position="absolute" marginTop="20px">
                            <Divider marginBottom="10px"/>
                            <Heading size="lg" marginBottom="20px">Popular posts</Heading>
                            <Link display="block" marginBottom="10px" textColor="var(--chakra-colors-purple-500)" onClick={() => router.push('/blog/digital-marketing-strategies-examples')}><u>Examples of successful marketing strategies</u></Link>
                            <Link display="block" textColor="var(--chakra-colors-purple-500)" onClick={() => router.push('/blog/effective-conversion-funnel-optimization')}><u>Effective conversion funnel optimization</u></Link>
                        </Flex>
                    </Box> */}
                </>}
            </Box>
        </Flex>
	)
}
export default ReminderForm
